module.exports = __webpack_public_path__ + "static/media/arrow-link.8c9428f7.svg";